module.exports = __webpack_public_path__ + "img/apple.8bb7b7d5.svg";